import { Injectable } from '@angular/core';
import { fromEvent, map, merge, Observable, Observer } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  checkConnection$: Observable<boolean> = merge(
    fromEvent(window, 'offline').pipe(map(() => false)),
    fromEvent(window, 'online').pipe(map(() => true)),
    new Observable<boolean>((sub: Observer<boolean>) => {
      sub.next(navigator.onLine);
      sub.complete();
    })
  );

  checkConnection(): Observable<boolean> {
    return this.checkConnection$;
  }
}
